import React, { useEffect, useState } from 'react'
import SearchList from '../../sharedComponent/SearchList/SearchList'
import { Spinner, Modal } from 'react-bootstrap'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useLazyQuery } from '@apollo/client'
import { GLOBAL_CONSTANTS } from '../../../utils/GlobalConstants'
import {
  GET_PRODUCT_AUDIT_DATA,
  GET_PRODUCT_AUDIT_LIST,
  GET_SALESCHANNEL_AGENT_AUDIT_DATA,
  GET_SALESCHANNEL_AGENT_AUDIT_LIST,
  GET_SALES_CHANNEL_AUDIT_DATA,
  GET_SALES_CHANNEL_AUDIT_LIST,
  GET_SCRIPT_AUDIT_DATA,
  GET_SCRIPT_AUDIT_LIST,
} from '../../../utils/GraphQLAPI'
import { ACTIVITYLISTCONFIGS } from './AuditTrailUtils'
import { createPortal } from 'react-dom'
import backIcon from '../../../_metronic/images/back_icon.svg'

type LocationState = {
  itemType: any
  itemId: string
  salesId: string
}

const ReusableAuditTrail: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const getUrlParams = useParams()
  const itemId = (location.state as LocationState)?.itemId
  const itemType = (location.state as LocationState)?.itemType
  const salesId = (location.state as LocationState)?.salesId //only for systemadmin Sales channel to navigate back to edit page
  const [filterOptions, setFilterOptions] = useState({
    perPage: 10,
    orderBy: 'DESC',
    productId: itemType === 'Product' ? itemId : undefined,
    scriptId: itemType === 'Script' ? itemId : undefined,
    salesChannelId: itemType === 'SalesChannel' ? itemId : undefined,
    agentId: itemType === 'Agent' ? itemId : undefined,
    page: 1,
  })

  const [modalConfig, setModalConfig] = useState({
    show: false,
  })

  const handleModalClose = () => {
    setModalConfig((prev) => {
      return { ...prev, show: false }
    })
  }
  const handleBackNavigation = () => {
    const basePath = `/${getUrlParams.adminUser}`
    let backPath = basePath

    switch (itemType) {
      case 'Product':
        backPath += '/products'
        break
      case 'Script':
        backPath += '/tpvscript'
        break
      case 'SmartDocs':
        backPath += '/smart-docs'
        break
      case 'SalesChannel':
        backPath += '/sales-channel-list'
        break
      case 'Agent':
        localStorage.setItem('salesEditId', salesId)
        backPath += '/sales-channel-list/edit-salesChannel'
        break
      default:
        break
    }

    navigate(backPath, {})
  }
  const loadAPI = (itemTypes: string, apiType: string) => {
    switch (itemTypes) {
      case 'Script':
        return apiType === 'list' ? GET_SCRIPT_AUDIT_LIST : GET_SCRIPT_AUDIT_DATA
      case 'SalesChannel':
        return apiType === 'list' ? GET_SALES_CHANNEL_AUDIT_LIST : GET_SALES_CHANNEL_AUDIT_DATA
      case 'Agent':
        return apiType === 'list'
          ? GET_SALESCHANNEL_AGENT_AUDIT_LIST
          : GET_SALESCHANNEL_AGENT_AUDIT_DATA
      default:
        return apiType === 'list' ? GET_PRODUCT_AUDIT_LIST : GET_PRODUCT_AUDIT_DATA
    }
  }
  const [getItemAuditList, { data, loading }] = useLazyQuery(loadAPI(itemType, 'list'), {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })

  useEffect(() => {
    getItemAuditList({
      variables: {
        ...filterOptions,
      },
    })
  }, [itemType, filterOptions])

  const modalsRoot = document.getElementById('root-modals') || document.body
  const [getItemAuditData, { data: auditData, loading: auditdataLoading }] = useLazyQuery(
    loadAPI(itemType, 'data'),
    {
      fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    }
  )

  return (
    <>
      <div
        className='d-flex flex-row justify-content-between'
        style={{ height: '48px', marginBottom: '20px' }}
      >
        <div className='d-flex'>
          <div
            className='svg-icon svg-icon-3 svg-icon-muted me-4 mt-4 align-items-center'
            style={{ cursor: 'pointer' }}
            onClick={() => handleBackNavigation()}
          >
            <img src={backIcon} alt='back' />
          </div>
          <div className='d-flex flex-column'>
            <span className='fs-3 fw-bold text-gray-900'>Audit trail </span>
            <span className='text-gray-500 fw-semibold lh-20px fs-7'>{itemType} - Audit</span>
          </div>
        </div>
      </div>
      <SearchList
        idFieldName='id'
        filterOptions={filterOptions}
        setFilterOptions={setFilterOptions}
        listCount={data?.[`get${itemType}AuditList`]?.totalCount}
        paginatedCount={data?.[`get${itemType}AuditList`]?.recordList?.length}
        listLoading={loading}
        isSearchable={false}
        apiData={data?.[`get${itemType}AuditList`]?.recordList}
        listConfigs={ACTIVITYLISTCONFIGS}
        onRowClick={(rowData: any) => {
          getItemAuditData({
            variables:
              itemType === 'Script' || itemType === 'SalesChannel'
                ? {
                  sectionId: rowData.sectionId,
                  section: rowData.section,
                  timeChanged: rowData.timeChanged,
                }
                : {
                  [itemType === 'Product' ? 'productId' : 'sectionId']: rowData.sectionId,
                  timeChanged: rowData.timeChanged,
                },
          })
          setModalConfig((prev) => ({ ...prev, show: true }))
        }}
        isActiveApiFieldName=''
      />
      {createPortal(
        <Modal
          id='kt-modal_create_app'
          tabIndex={-1}
          aria-hidden='true'
          dialogClassName='modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg'
          show={modalConfig.show}
          onHide={() => handleModalClose()}
          backdrop={true}
        >
          <div className='modal-header'>
            <h2>Activity Log</h2>
          </div>
          <div className='hover-scroll-overlay-y mh-550px product-form'>
            {auditdataLoading ? (
              <div className='text-center h-300px'>
                <Spinner animation='border' className='text-gray-600' role='status'>
                  <span className='visually-hidden'>Loading...</span>
                </Spinner>
              </div>
            ) : (
              <div className='px-7 py-5'>
                <div className='py-5'>
                  <table className='table table-row-dashed table-row-gray-300 gy-7'>
                    <thead>
                      <tr className='fw-bold text-gray-800'>
                        <th className='fs-6' style={{ width: '150px' }}>
                          Field
                        </th>
                        <th className='fs-6' style={{ width: '150px' }}>
                          Old Data
                        </th>
                        <th className='fs-6' style={{ width: '150px' }}>
                          New Data
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {auditData?.[`get${itemType}AuditDataBy${itemType}Id`]?.changes.map(
                        (data: any, index: number) => (
                          <tr key={index}>
                            <td
                              className='text-gray-500 fs-6 fw-semibold px-0'
                              style={{ width: '150px' }}
                            >
                              {data?.fieldName}
                            </td>
                            <td
                              className={`fs-6 fw-semibold ${data?.fieldName === 'Products'
                                ? 'text-danger'
                                : 'text-gray-500 px-0'
                                }`}
                              style={{ width: '150px' }}
                            >
                              {data?.fieldName === 'Products' ? (
                                data?.oldValue == null ? (
                                  '-'
                                ) : (
                                  <div style={{ whiteSpace: 'pre-wrap' }}>
                                    {JSON.parse(data?.oldValue).map(
                                      (product: string, productIndex: number, array: string[]) => (
                                        <React.Fragment key={productIndex}>
                                          <div className='text-danger'>
                                            {product}
                                            {productIndex < array.length - 1 && <span>, </span>}
                                          </div>
                                        </React.Fragment>
                                      )
                                    )}
                                  </div>
                                )
                              ) : data?.oldValue == null ? (
                                '-'
                              ) : (
                                data?.oldValue
                              )}
                            </td>
                            <td
                              className={`fs-6 fw-semibold ${data?.fieldName === 'Products'
                                ? 'text-success'
                                : 'text-gray-500 px-0'
                                }`}
                              style={{ width: '150px' }}
                            >
                              {data?.fieldName === 'Products' ? (
                                data?.newValue == null ? (
                                  '-'
                                ) : (
                                  <div style={{ whiteSpace: 'pre-wrap' }}>
                                    {JSON.parse(data?.newValue).map(
                                      (product: string, productIndex: number, array: string[]) => (
                                        <React.Fragment key={productIndex}>
                                          <div className='text-success'>
                                            {product}
                                            {productIndex < array.length - 1 && <span>, </span>}
                                          </div>
                                        </React.Fragment>
                                      )
                                    )}
                                  </div>
                                )
                              ) : data?.newValue == null ? (
                                '-'
                              ) : (
                                data?.newValue
                              )}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
          <div
            className='modal-footer sticky-bottom bg-white'
            style={{ borderRadius: '0 0 20px 20px', zIndex: '2' }}
          >
            <button
              onClick={() => handleModalClose()}
              className='btn btn-light-primary'
              data-kt-stepper-action='submit'
            >
              Close
            </button>
          </div>
        </Modal>,
        modalsRoot
      )}
    </>
  )
}
export default ReusableAuditTrail
